import React, {useEffect, useState} from 'react';
import {components} from 'react-select';

import {SelectBase} from 'components/Forms/FormBases';
import {getCountryNameById} from 'utils/locales';
import {LabelAddressSites} from 'components/Labels';

import {getCESites} from 'api/certified-entities';
import {alertByError} from 'utils/alerts';
import cx from 'classnames';

import styles from './styles.module.scss';
import MuiIcon from 'components/Icons/MuiIcon';

const MenuList = ({children, onClick, ...props}) => {
  return (
    <components.MenuList {...props} className="py-0">
      {children}
      <div
        className={cx(
          'cursor-pointer text-primary p-2 border-top text-center',
          styles['create-menulist']
        )}
        onClick={onClick}
      >
        <MuiIcon name="add" /> Create new site for this entity
      </div>
    </components.MenuList>
  );
};

const defaultProps = {
  placeholder: 'Enter / Select Main Site',
  isSearchable: false,
  getOptionLabel: (option) => {
    const {full_address, street, city, state, countries_id, post_code} = option;

    const country = !!countries_id && getCountryNameById(countries_id);

    return (
      <LabelAddressSites
        address={full_address}
        street={street}
        city={city}
        state={state}
        country={country}
        postcode={post_code}
      />
    );
  },
  getOptionValue: (option) => option.ce_site_id,
  getSites: getCESites,
  name: 'ce_site_id',
};

const SelectMainSite = (props) => {
  const {
    menuListProps,
    name,
    selectedCE,
    filters,
    onChange,
    getSites,
    isSearchable,
    ...rest
  } = props;

  const {ce_id} = selectedCE || {};

  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  async function getOptions() {
    setIsLoading(true);
    setOptions([]);
    try {
      const {data} = await getSites(ce_id, {
        ...filters,
      });

      setOptions(data);
    } catch (e) {
      alertByError(e);
      setOptions([]);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!!ce_id) getOptions();
  }, [ce_id]);

  const handleChange = (option) => {
    if (onChange) {
      onChange(option);
    }
    return option;
  };

  return (
    <React.Fragment>
      <SelectBase
        isSearchable={isSearchable}
        isLoading={isLoading}
        name={name}
        components={{
          MenuList: (props) => <MenuList {...props} {...menuListProps} />,
        }}
        options={options}
        openMenuOnClick={true}
        onChange={handleChange}
        {...rest}
      />
    </React.Fragment>
  );
};

SelectMainSite.defaultProps = defaultProps;

export default SelectMainSite;
